import attachEnterAsClick from 'utils/attachEnterAsClick';
import $ from 'jquery';

const printShareInit = () => {
    const $printBtn = $('.print-control');
    if (!$printBtn.length) { return; }

    $printBtn.on('click', () => {
        window.print();
    });
    attachEnterAsClick($printBtn);
};

$(() => {
    printShareInit();
});



// WEBPACK FOOTER //
// ./src/components/print-share/c-print-share.js